import Leger from "../../../../../components/categories/siakad/laporan_adab/leger/Home"
export default function Home() {
  
  return (
    <Leger />
  );
}
